import React from 'react';

import { useQueryParams } from 'src/hooks';
import SearchBar from 'src/Components/Search/SearchBar';
import SearchResults from 'src/Components/Search/SearchResults';

function SearchView({ ...rest }) {
  const query = useQueryParams();

  return (
    <div {...rest}>
      <SearchBar value={query.get('q')} />
      <SearchResults term={query.get('q')} />
    </div>
  );
}

export default SearchView;
